import React from "react";
function ErrorPage() {
  return <>Not Found</>;
}

export default React.memo(ErrorPage);
